import React from 'react';
import { css, useTheme } from '@emotion/react';

type Props = {
    children: React.ReactNode,
};

const ButtonGroupContainer: React.FC<Props> = ({ children }) => {
    const theme = useTheme();

    const style = css`
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        column-gap: 20px;

        margin-top: 50px;

        ${theme.breakpoints.down('md')} {
            margin-top: 20px;
        }
    `;

    return (
        <div css={style}>
            { children }
        </div>
    );
};

export default ButtonGroupContainer;